/**
 * PhrasalVerb deck — hand-coded sample (~12 entries) so PhrasalVerbQuiz
 * works end-to-end before the PHaVE 150 ingest runs. Replaced by the
 * full PHaVE list once the user extracts it from the PDF (see
 * data/sources/README.md → PHaVE manual extraction).
 *
 * License: CC BY-SA 4.0 (matches the eventual PHaVE-derived data).
 *
 * Card shape: `front` is the full phrasal verb. The quiz parses it as
 * `[verb, ...particles]` and blanks the particle(s) at quiz time.
 */

import type { EnglishCard } from '../types.js';

export const phrasalVerbs: EnglishCard[] = [
  {
    id: 'give-up',
    front: 'give up',
    back: 'to stop trying',
    pos: 'phrasal-verb',
    cefr: 'B1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'Don\'t give up — you\'re almost there!',
      sourceUrl: ''
    }
  },
  {
    id: 'look-up',
    front: 'look up',
    back: 'to find information in a book or online',
    pos: 'phrasal-verb',
    cefr: 'A2',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'I had to look up the word in the dictionary.',
      sourceUrl: ''
    }
  },
  {
    id: 'look-after',
    front: 'look after',
    back: 'to take care of someone or something',
    pos: 'phrasal-verb',
    cefr: 'A2',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'Can you look after my cat while I\'m away?',
      sourceUrl: ''
    }
  },
  {
    id: 'look-for',
    front: 'look for',
    back: 'to try to find something',
    pos: 'phrasal-verb',
    cefr: 'A2',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'I\'m looking for my keys — have you seen them?',
      sourceUrl: ''
    }
  },
  {
    id: 'take-off',
    front: 'take off',
    back: 'to remove (clothing); also: an airplane leaves the ground',
    pos: 'phrasal-verb',
    cefr: 'A2',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'Please take off your shoes before entering.',
      sourceUrl: ''
    }
  },
  {
    id: 'take-over',
    front: 'take over',
    back: 'to assume control of something',
    pos: 'phrasal-verb',
    cefr: 'B1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'She will take over the project next month.',
      sourceUrl: ''
    }
  },
  {
    id: 'get-up',
    front: 'get up',
    back: 'to leave bed in the morning',
    pos: 'phrasal-verb',
    cefr: 'A1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'I get up at seven every weekday.',
      sourceUrl: ''
    }
  },
  {
    id: 'get-over',
    front: 'get over',
    back: 'to recover from an illness or sad event',
    pos: 'phrasal-verb',
    cefr: 'B1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'It took her months to get over the breakup.',
      sourceUrl: ''
    }
  },
  {
    id: 'put-on',
    front: 'put on',
    back: 'to dress in something',
    pos: 'phrasal-verb',
    cefr: 'A1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'It\'s cold outside — put on a coat.',
      sourceUrl: ''
    }
  },
  {
    id: 'turn-on',
    front: 'turn on',
    back: 'to make a device start working',
    pos: 'phrasal-verb',
    cefr: 'A1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'Could you turn on the light, please?',
      sourceUrl: ''
    }
  },
  {
    id: 'turn-off',
    front: 'turn off',
    back: 'to make a device stop working',
    pos: 'phrasal-verb',
    cefr: 'A1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'Don\'t forget to turn off the stove.',
      sourceUrl: ''
    }
  },
  {
    id: 'come-back',
    front: 'come back',
    back: 'to return to a place',
    pos: 'phrasal-verb',
    cefr: 'A1',
    tags: ['phrasal-verb'],
    example: {
      sentence: 'When will you come back from your trip?',
      sourceUrl: ''
    }
  }
];

export default phrasalVerbs;
